/* eslint-disable react/prop-types */
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Text,
  LoadingDot,
  Table,
  Button,
  Icon,
  Spacer,
} from 'components/atoms';
import { Tooltip } from 'components/molecules'
import { injectIntl, FormattedMessage } from 'react-intl'
import { intlType } from 'types'
import { computeDateDistance } from 'services/generators';
import { UsersAvatarList } from 'containers'

const PageTable = memo(({
  pages, loading, intl, noDataText, onAddPage, page,
}) => {
  const [data, setData] = useState([])
  useEffect(() => {
    if (!loading) setData([...pages])
  }, [pages, loading])

  return (
    <Table
      data={data}
      getTrProps={(state, rowInfo) => {
        if (!rowInfo || !rowInfo.original || !rowInfo.original.id) return {}
        const { original } = rowInfo
        if (rowInfo && rowInfo.original && rowInfo.original.id) {
          return {
            onClick: (e) => {
              e.preventDefault()
              e.stopPropagation();
              onAddPage(original)
            }
          }
        }
        return {
        }
      }}
      columns={[
        {
          Header: '',
          accessor: 'actions',
          resizable: false,
          width: 60,
          Cell: () => (
            <Tooltip tooltip="associar página" placement="top">
              <CellStart>
                <Button modifiers={['small', 'primaryHover']}>
                  <Icon icon="fal fa-plus" height={16} />
                </Button>
              </CellStart>
            </Tooltip>
          ),
        },
        {
          Header: intl.formatMessage({ id: 'page' }),
          accessor: 'title',
          Cell: ({ value }) => (
            <Cell value={value} loadingDots={loading} />
          ),
        },
        {
          Header: intl.formatMessage({ id: 'subwebs.slug' }),
          accessor: 'slug',
          Cell: ({ value }) => (
            <Cell value={`/${value}`} loading={loading} />
          )
        },
        {
          Header: intl.formatMessage({ id: 'table.title.last' }),
          accessor: 'contributors',
          Cell: ({ value, original: { updatedAt } }) => (
            <Cell loading={loading}>
              {value instanceof Array
                && (
                  <>
                    <Spacer right="xs2">
                      <UsersAvatarList users={value} loading={loading} maxItems={1} />
                    </Spacer>
                  </>
                )
              }
              <Text modifiers={['light']}>
              há
                {' '}
                {computeDateDistance(updatedAt)}
              </Text>
            </Cell>
          ),
        },
      ]}
      defaultPageSize={10}
      minRows={0}
      className="-striped -highlight"
      noDataText={noDataText || 'Não foram encontradas subwebs'}
      sortable={false}
      showPagination={false}
      loading={loading}
      loadingText="A carregar..."
      page={page}
    />
  );
});

const Cell = ({
  value, loadingDots, loading, children = null
}) => {
  if (loadingDots) return <LoadingDot />
  if (loading) return <LoadingCell />
  if (!value && children === null) {
    return (
      <Text modifiers={['lighter']}>
        <FormattedMessage id="error.missing" />
      </Text>
    )
  }
  if (children !== null) return <>{children}</>
  return <Text modifiers={['light']}>{value}</Text>
};

const LoadingCell = styled.div`
  width: 80px;
  height: ${props => props.theme.sizes.s};
  background-color: ${props => props.theme.colors.bgLighterS};
`

const CellStart = styled.div`
  width: 100%;
`

PageTable.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string,
      lastUpdated: PropTypes.string,
      slug: PropTypes.string,
      state: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
  onAddPage: PropTypes.func,
  page: PropTypes.number,
};

PageTable.defaultProps = {
  pages: [],
  loading: true,
  noDataText: null,
  onAddPage: () => { },
  page: 0,
}


export default injectIntl(PageTable);
